import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.152 10.9l-9.015 9.015a5.25 5.25 0 01-7.425-7.425l9.016-9.015a3.5 3.5 0 114.95 4.95l-8.662 8.662a1.75 1.75 0 11-2.475-2.475l7.601-7.602"
    })
  ]))
}